import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, isPaginationSlice, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

const entityDeleteReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    const nr = networkActionReducer<T, E>(type);
    return function entityDeleteReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let data = isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state];

            data = action.payload.status !== RequestStatus.SUCCEEDED ?
                deepAssign(data, data.map(item => action.payload.entityID === item.ID ? nr(item, action) : item)) :
                deepAssign(data, data.filter(item => action.payload.entityID !== item.ID));

            if (action.payload.status === RequestStatus.SUCCEEDED && isPaginationSlice(state)) {
                state = deepAssign(state, {
                    Count: state.Count - 1,
                    TotalCount: state.Count - 1,
                })
            }

            return isNetworkArray(state) ? deepAssign(state, { Data: data }) : isSimpleArray(state) ? data : data[0];
        }
        return state;
    };
}

export default entityDeleteReducer;